// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"60e1b2f2","453":"c5212c92","480":"e04da6a0","537":"3fa7e0a3"}[chunkId] + ".chunk.js";
};